import React from "react";

import StatusText from "../../components/status-text";

//
//  TODO: When we have user avatars available
// import IconBox from '../../components/icon-box';
//
// export default ({ title, image, subTitle }) => {
//   return (
//     <IconBox image={image}>
//       <div className="center pb-4">
//         <StatusText title={title} subTitle={subTitle} />
//       </div>
//     </IconBox>
//   );
// };

const UserHeader = ({ title, image, subTitle }) => {
  return (
    <div className="box center p-3 mb-4">
      <StatusText title={title} subTitle={subTitle} />
    </div>
  );
};
export default UserHeader;
